import { createSelector } from 'reselect';
import _ from 'lodash';

import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

export const getCurrentSelectedMenu = state =>
  _.get(state, 'PointOfSaleState.mealTypes.currentSelectedMenu');

export const getCurrentSelectedTabMenu = state =>
  _.get(state, 'PointOfSaleState.mealTypes.currentSelectedTabMenu');

export const getMealTypesSearchText = state =>
  _.get(state, 'PointOfSaleState.mealTypes.searchText');

export const getSaveOrderNumFetching = state =>
  _.get(state, 'PointOfSaleState.mealTypes.saveOrderNumFetching', false);

export const getSaveOrderNumError = state =>
  _.get(state, 'PointOfSaleState.mealTypes.saveOrderNumError', null);

export const getSaveOrderNumSuccess = state =>
  _.get(state, 'PointOfSaleState.mealTypes.saveOrderNumSuccess', false);

export const getFoodItems = state =>
  _.get(state, 'PointOfSaleState.mealTypes.foodItems');

const getServedItems = state =>
  _.get(state, 'PointOfSaleState.common.servedItems', []);

const getItemCategories = state =>
  _.get(state, 'PointOfSaleState.common.itemCategories', []);

export const getSelectedMenuServedItems = createSelector(
  getServedItems,
  getCurrentSelectedMenu,
  (servedItems, selectedMenu) => {
    const mealType = MealTypesEnum[selectedMenu];
    return servedItems.filter(item => {
      return item.ItemId[0] === mealType;
    });
  }
);

export const getSelectedMealTypesTabsMenus = createSelector(
  [
    getFoodItems,
    getCurrentSelectedTabMenu,
    getCurrentSelectedMenu,
    getItemCategories,
  ],
  (
    allFoodItems,
    currentSelectedTabMenu,
    currentSelectedMenu,
    itemCategories
  ) => {
    if (currentSelectedMenu) {
      const allFoodItemsClone = _.cloneDeep(allFoodItems);

      const AllMenuConstants = {
        label: 'All Food Items',
        key: 'All Food Items',
        selected: false,
      };

      const UncategorizedMenuConstant = {
        label: 'Uncategorized',
        key: 'Uncategorized',
        selected: false,
      };
      const tabs = [];
      allFoodItemsClone[currentSelectedMenu][
        'All Food Items'
      ] = AllMenuConstants;

      allFoodItemsClone[currentSelectedMenu][
        'Uncategorized'
      ] = UncategorizedMenuConstant;
      Object.keys(allFoodItemsClone[currentSelectedMenu]).map(item => {
        const tab = {};
        // if item's ItemCategoryId is null, ignore, the tab is converged to Uncategorized
        if (item === 'null' || item === null) {
          // eslint-disable-next-line
          return;
        }
        let label = item;

        if (item !== 'All Food Items' || item !== 'Uncategorized') {
          const itemCategory = itemCategories.find(
            ic => ic.Id === Number(item)
          );
          label = itemCategory ? itemCategory.Description : label;
        }
        tab.label = label;
        tab.key = item;
        tab.selected = tab.key === currentSelectedTabMenu;
        return tabs.push(tab);
      });

      return _.sortBy(tabs, tab => {
        if (tab.label === 'All Food Items') return -1;
        if (tab.label === 'Uncategorized') return 1;
        return 0;
      });
    }
  }
);

export const filteredAllFoodItems = createSelector(
  [
    getFoodItems,
    getMealTypesSearchText,
    getCurrentSelectedMenu,
    getCurrentSelectedTabMenu,
  ],
  (
    allFoodItems,
    servedItemSearchText,
    currentSelectedMenu,
    currentSelectedTabMenu
  ) => {
    const allFoodItemsClone = _.cloneDeep(allFoodItems);
    if (currentSelectedMenu) {
      const tabMenus = Object.keys(allFoodItemsClone[currentSelectedMenu]);
      allFoodItemsClone[currentSelectedMenu]['All Food Items'] = [];
      allFoodItemsClone[currentSelectedMenu]['Uncategorized'] = [];
      const foodItemsUnion = [];
      tabMenus.map(tab =>
        foodItemsUnion.push(allFoodItemsClone[currentSelectedMenu][tab])
      );

      const allItems = _.union(...foodItemsUnion);

      allFoodItemsClone[currentSelectedMenu]['All Food Items'] = allItems;

      allFoodItemsClone[currentSelectedMenu]['Uncategorized'] = allItems.filter(
        f => f.ItemCategoryId === null
      );

      if (servedItemSearchText) {
        const trimmedSearchText = _.trim(servedItemSearchText);
        const filteredFoodItem = allFoodItemsClone;
        const searchResult = [];
        _.each(
          allFoodItemsClone[currentSelectedMenu][currentSelectedTabMenu],
          foodItem => {
            if (foodItem.selected) {
              searchResult.push(foodItem);
              filteredFoodItem[currentSelectedMenu][
                currentSelectedTabMenu
              ].push(foodItem);
            } else if (
              foodItem.Description.toLowerCase().indexOf(
                trimmedSearchText.toLowerCase()
              ) > -1
            ) {
              searchResult.push(foodItem);
              filteredFoodItem[currentSelectedMenu][
                currentSelectedTabMenu
              ].push(foodItem);
            }
          }
        );
        filteredFoodItem[currentSelectedMenu][
          currentSelectedTabMenu
        ] = searchResult;
        return filteredFoodItem;
      } else {
        return allFoodItemsClone;
      }
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/state/selector.js